import React, { useEffect, useState } from 'react';
// javascipt plugin for creating charts
import Chart from 'chart.js';
// react plugin used to create charts
import { Bar } from 'react-chartjs-2';
// reactstrap components
import { isEmpty, map, toNumber } from 'lodash-es';
import { parseOptions } from 'variables/charts';
import { chartOptions } from 'variables/charts';
import { isFloat } from '../../utils/misc';
import { Spinner, Card, Row, Col } from 'reactstrap';
import { useChargerHostAnalytics } from '../../utils/queries/hostQueries';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { find, orderBy } from 'lodash';
parseOptions(Chart, chartOptions());
Chart.plugins.register(ChartDataLabels);

const ChargerwiseAnalytics = ({
  activeTab,
  granularity,
  startDate,
  endDate,
  handleBarClick,
  selectedBarIndex = -1,
  chargersDetails,
}) => {
  const [data, setData] = useState([]);
  const {
    data: respData,
    isLoading,
    error,
  } = useChargerHostAnalytics({
    startDate,
    endDate,
  });

  useEffect(() => {
    const orderKey = ['KWH', 'AMOUNT', 'SESSIONS'];
    const sortedData = orderBy(respData, orderKey[activeTab - 2], 'desc');
    setData(sortedData);
  }, [activeTab, respData]);

  if (isLoading) {
    <h1>Loading</h1>;
  }
  if (error) {
    <h1>Error</h1>;
  }

  const getChargerDetails = (cpid) => {
    const charger = find(chargersDetails, { ID: cpid });
    return charger?.ADDRESS;
  };

  const defaultBarColor = '#fb6340';
  const selectedBarColor = '#414141';

  let chartData = {
    options: {
      scales: {
        yAxes: [
          {
            display: false,
          },
        ],
      },
      tooltips: {
        displayColors: false,
        callbacks: {
          title: (tooltipItem) => getChargerDetails(tooltipItem[0]?.label),
          label: (tooltipItem) => '',
          footer: (tooltipItem) => '',
        },
      },
      layout: {
        padding: {
          top: 50,
        },
      },
      onClick: (evt, ele) => {
        handleBarClick(data[ele[0]?._index]?.CPID, ele[0]?._index);
      },
    },
    plugins: [ChartDataLabels],
    data: {
      labels: map(data, (row) => {
        return row.CPID;
      }),
      datasets: [
        {
          label: '',
          data: map(data, (row) => {
            if (activeTab === 2) {
              return isFloat(toNumber(row.KWH_CONSUMED))
                ? toNumber(row.KWH_CONSUMED).toFixed(2)
                : toNumber(row.KWH_CONSUMED);
            } else if (activeTab === 3) {
              return isFloat(toNumber(row.AMOUNT_CONSUMED) / 100)
                ? (toNumber(row.AMOUNT_CONSUMED) / 100).toFixed(2)
                : toNumber(row.AMOUNT_CONSUMED) / 100;
            } else if (activeTab === 4) {
              return toNumber(row.SESSIONS);
            }
          }),
          backgroundColor: map(data, (row, index) =>
            index === selectedBarIndex ? selectedBarColor : defaultBarColor,
          ),
          maxBarThickness: 10,
          datalabels: {
            font: {
              weight: 400,
              size: '12',
            },
            color: 'black',
            backgroundColor: 'transparent',
            align: 'start',
            anchor: 'end',
            clamp: true,
            offset: -25,
            borderRadius: 5,
            padding: 4,
            opacity: 0.8,
            textAlign: 'center',
            formatter: function (value, context) {
              if (activeTab === 2) {
                return `${value} KWh`;
              } else if (activeTab === 3) {
                return `₹ ${value}`;
              } else if (activeTab === 4) {
                return `${value}`;
              }
            },
            listeners: {
              click: (context) => {
                handleBarClick(granularity, data[context.dataIndex]?.DATE);
              },
            },
          },
        },
      ],
    },
  };
  return (
    <>
      <Card className="shadow" style={{ marginTop: 10 }}>
        <Row>
          <Col
            sm="12"
            md="12"
            lg="12"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
            className="mt-3"
          >
            <div className="px-3 mt--1">
              <h2 className="text mb-0">Chargerwise Analytics</h2>
              <p className="text mb-0" style={{ fontWeight: 500 }}>
                {startDate} - {endDate}
              </p>
            </div>
          </Col>
          <Col>
            <div
              style={{
                display: 'flex',
                height: '400px',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {isLoading ? (
                <Spinner style={{ color: '#2675b8' }} />
              ) : error ? (
                'Oops something went wrong'
              ) : isEmpty(data) ? (
                'We dont have any Analytics report'
              ) : (
                <Bar data={chartData?.data} options={chartData?.options} />
              )}
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ChargerwiseAnalytics;
